import React from 'react';
import { useHistory, matchPath } from 'react-router-dom';

import { appRoutes } from 'features/app/routes/paths';
import { rootPaths } from 'routes/paths';

import { ReactComponent as AppLogoIcon } from 'assets/icons/app-logo-icon.svg';

import { useStyles } from './styles';

export const Logo: React.FC = () => {
  const classes = useStyles();

  const history = useHistory();

  const handleClick = () => {
    if (matchPath(history.location.pathname, { path: appRoutes.static.root })) {
      history.push(appRoutes.static.root);
    } else {
      history.push(rootPaths.static.root);
    }
  };

  return <AppLogoIcon className={classes.root} onClick={handleClick} />;
};
